<app-section-loader [loading]="loading"></app-section-loader>
<ng-container *ngIf="!loading">
  <div class="mContent__header bg-primary py-3 px-5">
    <h1 class="text-white mb-1">Student Details</h1>
    <div class="mControls">
      <div class="input-group mr-auto">
        <h2 class="m-0 h3 text-white align-items-center d-inline-flex">
          <mat-icon class="rounded-icon mr-2">person</mat-icon>
          {{ student?.first_name }}
          {{ isTutor ? (student?.second_name ? maskSingleName(student?.second_name) : "" ) : student?.second_name}}
          {{ isTutor ? (student?.last_name ? maskSingleName(student?.last_name) : "") : student?.last_name }}
        </h2>
      </div>
      <div class="mControls__right d-flex align-items-center gap-2">
        <button
          *ngIf="
            loggedInUser !== tutorRoleId &&
            student?.school?.uuid === TRAINING_SCHOOL_UUID
          "
          mat-raised-button
          class="btn-clear-engagement"
          (click)="onClearEngagement()"
        >
          <mat-icon>delete_sweep</mat-icon>
          Clear Engagement
        </button>
        <button
          *ngIf="loggedInUser !== tutorRoleId"
          mat-raised-button
          color="warn"
          (click)="ActivateOrDeactivate()"
        >
          <mat-icon>block</mat-icon>
          {{ student?.is_active ? "Deactivate" : "Activate" }} Student
        </button>

        <button
          *ngIf="loggedInUser !== tutorRoleId && activeTabIndex < 3"
          [disabled]="!student?.is_active && activeTabIndex != 0"
          mat-raised-button
          (click)="updateButtonAction(studentId)"
        >
          <mat-icon>edit</mat-icon>
          {{ updateButtonText[activeTabIndex] }}
        </button>

        <button
          mat-raised-button
          [disabled]="!student?.is_active && activeTabIndex != 0"
          (click)="goToStudentList()"
        >
          <mat-icon>done</mat-icon>
          Done
        </button>

      </div>

    </div>
  </div>

  <div class="scroll flex-fill overflow-auto py-3 px-5">
    <div class="container p-0 h-100">
      <div class="d-flex flex-column h-100 tab-group-area">
        <mat-tab-group
          dynamicHeight
          [(selectedIndex)]="activeTabIndex"
          (selectedTabChange)="tabChanged($event)"
        >
          <mat-tab>
            <ng-template mat-tab-label>Overview</ng-template>
            <div class="h-100 position-relative">
              <app-section-loader
                [loading]="loadingDetails"
              ></app-section-loader>
              <app-overview [student]="student"></app-overview>
            </div>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>Progress</ng-template>
            <div class="h-100">
              <app-progress [student]="student"></app-progress>
            </div>
          </mat-tab>
          <div *ngIf="loggedInUser != tutorRoleId">
          <mat-tab>
            <ng-template mat-tab-label>Scores</ng-template>
            <div class="h-100">
              <app-scores [studentId]="studentId"></app-scores>
            </div>
          </mat-tab>
          </div>
          <mat-tab>
            <ng-template mat-tab-label>Absences</ng-template>
            <div class="h-100">
              <app-absence [student]="student"></app-absence>
            </div>
          </mat-tab>
          <div *ngIf="loggedInUser != tutorRoleId">
            <mat-tab
              *ngIf="
                student?.is_active == 1 &&
                student?.control_group == 0 &&
                student?.grade?.grade_level !== '5th'
              "
            >
              <ng-template mat-tab-label>Assign Tutor</ng-template>
              <div class="h-100">
                <app-associates [student]="student"></app-associates>
              </div>
            </mat-tab>
          </div>
        </mat-tab-group>
      </div>
    </div>
  </div>
</ng-container>
